import { styled } from "@mui/material";

export const Section = styled('section')(({ theme }) => (props) => ({
    display: 'flex',
    justifyContent: 'center',
    padding: '48px  96px',
    minHeight: '70vh',
    [theme.breakpoints.down('md')]: {
        padding: '24px  48px'
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  24px ',
        flexDirection: 'column',
        gap: '30px',
        alignItems: 'center',
    },
    [theme.breakpoints.down('xs')]: {
        padding: '12px 12px',
        gap: '10px'

    },

}))
export const SectionImage = styled('div')(({ theme }) => (props) => ({
    width: '50%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        minHeight: '40vw'
    },
    [theme.breakpoints.down('xs')]: {
        minHeight: '190px'
    }
}))
export const SectionText = styled('div')(({ theme }) => (props) => ({
    width: '50%',
    [theme.breakpoints.down('sm')]: {
        width: '100%'
    }
}))
export const HeaderSection = styled('h3')(({ theme }) => (props) => ({
    fontSize: '24px',
    fontWeight: 800,
    lineHeight: '29px',
    letterSpacing: '0em',
    margin: '5px',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.down('xs')]: {
        display: 'none',

    }
}))
export const DscripSection = styled('div')(({ theme }) => (props) => ({
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0em',
    margin: '12px',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    "& > p ": {
        color: theme.palette.mode === 'light' ? theme.palette.text.light : theme.palette.text.dark,
        margin: 5,
    },
    "& > h2 ": {
        fontSize: '24px',
        fontWeight: 800,
        lineHeight: '29px',
        letterSpacing: '0em',
        margin: '5px',
    }
}))

export const IconSection = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '15%',
    margin: ' 24px 12px',

}))

